function mapLoad() {

	var mapIcon01 = new google.maps.LatLng(53.761842924552205, -2.4511548742037585);

	var stylez = [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}];

	var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Stops draggable on mobile phones
	var isDraggable = w > 480 ? true : false; // Stops draggable on mobile phones

	var mapOptions01 = {
		zoom: 14,
		center: mapIcon01,
		scaleControl: false, // Scale Control
		//scrollwheel: false, // Stops Mouse Wheel Controlling Map
		draggable: isDraggable, // Stops draggable on mobile phones
		mapTypeControl: false, // Stops Styles Changing
		panControl: false, // Removes Pan Circle
		streetViewControl: false, // Removes Pegman
		overviewMapControl: false, // Removes Overview Box
		mapTypeId: google.maps.MapTypeId.ROADMAP // HYBRID // SATELLITE // TERRAIN
	};


	var map = new google.maps.Map(document.getElementById("map_hippo"), mapOptions01);

	var hippoLoc = {
		url: '/themes/driveelectric/img/icons/location.svg',
		size: new google.maps.Size(50, 50), // Retina Marker Actual Width, Height
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(25, 25), // Marker Position e.g. Half-Width, Height for pin end OR Half-Width, Half-Height for centered
		scaledSize: new google.maps.Size(50, 50) // Retina Marker Wanted Width, Height
	};

	var marker01 = new google.maps.Marker({
		draggable: false,
		raiseOnDrag: false,
		icon: hippoLoc,
		map: map,
		position: mapIcon01
	});

	var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });
	map.mapTypes.set('map_hippo', mapType);
	map.setMapTypeId('map_hippo');


}

//$(document).ready(load);
//window.onload = mapLoad;
//mapLoad();
if (typeof google !== 'undefined' && google.maps) {
  google.maps.event.addDomListener(window, 'load', mapLoad);
}